<template>
  <div class="related-items">
      <div class="inner" v-if="items && items.length !== 0">
          <h2 class="related-title">Related</h2>
          <GridItem v-for="item in items" :key="item.id" :item="item" />
      </div>
  </div>
</template>

<script>
import GridItem from '@/components/GridItem.vue';

export default {
  name: 'related-items',
  components: {
    GridItem,
  },
  props: {
      items: {
          type: Array,
          default: [],
      },
      title: {
          type: String,
          default: 'Related',
      },
  },
}
</script>

<style lang="scss">
  .related-items {
    padding: clamp(1.875em, 2.286vw + 1.339em, 3.125em) var(--padding-x3);
    background: black;
    overflow: hidden;

    .related-title {
      grid-column: span 12;
      font-size: var(--medium-size);
      color: white;
    }
  }

  .related-items .inner {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: clamp(0.938rem, 5.143vw + -0.268rem, 3.75rem);
    font-size: 16px;
  }

  .related-items .inner > article {
    grid-column: span 12;
  }

  @media only screen and (min-width: 768px) {
    .related-items .inner > article {
      grid-column: span 4;
    }
  }

  body.body-class-ideas {
      .related-items {
          background: var(--gray);

          .col {
              a,a:hover,a:visited,a:active {
                  color: black;
              }
              .ui-button {
                  color: black;
                  border-color: black;
              }
          }
      }
  }

  @media only screen and (max-width: 767px) {
      .related-items {
          padding: var(--padding);
      }
  }
</style>
